import React from 'react'

const TradeCard = ({
  amount,
  name,
  token,
  type,
  date,
  scanLink,
  coinName
}) => {
  const link = `${scanLink}address/${token}`
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="block p-4 transition-all"
      style={{
        background: 'var(--section-bg)',
        borderBottom: '1px solid var(--border-color)'
      }}
    >
      <div className="grid grid-cols-4 gap-2 text-sm">
        <div className="truncate" style={{ color: 'var(--text-primary)' }}>
          {name}
        </div>
        <div style={{ color: type.toUpperCase() === 'SOLD' ? '#ef4444' : '#10B981' }}>
          {type.toUpperCase()}
        </div>
        <div style={{ color: 'var(--text-primary)' }}>
          {Number(amount).toFixed(3)} {type === 'bought' ? coinName : name}
        </div>
        <div className="text-right" style={{ color: 'var(--text-secondary)' }}>
          {date}
        </div>
      </div>
    </a>
  )
}

export default TradeCard
